import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
`

export const ViewScreen = styled.div`
    background: #fbe8eb;
    width: 98.46%;
    height: 97.12%;
    position: absolute;
    z-index: 3;
`

export const Title = styled.div`
    position: absolute;
    top: 17.44%;
    left: 9.8%;
    width: 50.94%;
`

export const Image = styled.img`
    position: absolute;
    width: 474px;
    height: 334px;
    right: 9.05px;
    bottom: 34px;
`
